export const PATHS = {
  LOGIN: "/login",
  DASHBOARD: "/dashboard",
  USERS: "/users",
  USER_DETAIL: (id: string) => `/users/${id}`,
  TRANSACTIONS: "/transactions",
  TRANSFERS: "/transfers",
  REMITTANCES: "/remittances",
  KYC: "/kyc",
  EXCHANGE_RATES: "/exchange-rates",
  PROVIDER_METHODS: "/provider-methods",
  PROVIDERS: "/providers",
  COUNTRIES: "/countries",
  WALLETS: "/wallets",
  COMMISSIONS: "/commissions",
  COMMISSION_LEDGER: "/commission-ledger",
  FX_RATE_CONFIGS: "/fx-rate-configs",
  SETTINGS: "/settings",
  LEVELS: "/levels",
  BLACKLIST: "/blacklist",
  COMPLIANCE: "/compliance",
  AUDIT_LOG: "/audit-log",
  PUSH_NOTIFICATIONS: "/push-notifications",
  PUSH_CAMPAIGNS: "/push-notifications",
  PUSH_CAMPAIGN_DETAIL: (id: string) => `/push-notifications/campaigns/${id}`,
  PUSH_CAMPAIGN_CREATE: "/push-notifications/campaigns/new",
  PUSH_SEND_TO_USER: "/push-notifications/send-to-user",
} as const;
